export const ENABLE_POST_COMMENTS_REQUEST = 'post/ENABLE_COMMENTS_REQUEST';
export const ENABLE_POST_COMMENTS_SUCCESS = 'post/ENABLE_COMMENTS_SUCCESS';
export const ENABLE_POST_COMMENTS_FAILURE = 'post/ENABLE_COMMENTS_FAILURE';
